export default "__VITE_ASSET__DITFXcIQ__"